<div class="row">
  <div class="col-sm-6">
    <div class="d-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800 text-center">Paquetes Activos</h1>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Tipo</th>
                <th>Precio</th>
                <th>Dias</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <th>Nombre</th>
                <th>Tipo</th>
                <th>Precio</th>
                <th>Dias</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </tfoot>
            <tbody>
              <tr *ngFor="let item of data">
                <td>{{item.titulo}}</td>
                <td>{{item.clase}}</td>
                <td>{{item.price}}</td>
                <td>{{item.days}}</td>
                <td *ngIf="item.status">Activo</td>
                <td *ngIf="!item.status">Desactivo</td>
                <td>
                  <div class="btn-group mr-1">
                    <button type="button" class="btn btn-primary  btn-sm" (click)="edit(item)">
                      <i class="fas fa-arrow-right"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>


    </div>

  </div>
  <div class="col-sm-6">
    <form [formGroup]="form">
      <div class="form-group">
        <label for="exampleFormControlInput1">Nombre</label>
        <input type="text" formControlName="titulo" class="form-control" id="exampleFormControlInput1" placeholder="">
      </div>
      <div class="form-group">
        <label for="exampleFormControlSelect1">Tipo</label>
        <select class="form-control" id="exampleFormControlSelect1" formControlName="clase">
          <option value="Ficha General">Ficha General</option>
        </select>
      </div>
      <div class="form-group">
        <label for="exampleFormControlInput1">Precio</label>
        <input type="number" class="form-control" formControlName="price" id="exampleFormControlInput1" placeholder="">
      </div>
      <div class="form-group">
        <label for="exampleFormControlInput1">Dias</label>
        <input type="number" class="form-control" formControlName="days" id="exampleFormControlInput1" placeholder="">
      </div>
      <div class="form-group">
        <label for="exampleFormControlSelect1">Estado</label>
        <select class="form-control" id="exampleFormControlSelect1" formControlName="status">
          <option value="true">Activo</option>
          <option value="false">Inactivo</option>
        </select>
      </div>
      <button type="button" class="btn btn-primary btn-block" *ngIf="!status" (click)="crear()">Crear</button>
      <button type="button" class="btn btn-secondary btn-block" *ngIf="status" (click)="save()">Editar</button>


    </form>
  </div>


</div>

<app-modal-loading [show]="modal_loading"></app-modal-loading>
